import produce from 'immer';
import Banner from '~/domain/model/Banner';
import { createCreator, createReducer, Reducer } from '~/helpers/util/reducers';

export type BannersState = {
  byId: Map<number, Banner>;
};

export type Update = {
  byId: Map<number, Banner>;
};

const prefix = '@banners';

export const Types = Object.freeze({
  CLEAR: `${prefix}/CLEAR`,
  UPDATE: `${prefix}/UPDATE`
});

export const initialState: BannersState = {
  byId: new Map()
};

const clearReducer: Reducer<BannersState, void> = state => {
  return produce(state, draft => {
    draft.byId = initialState.byId;
  });
};

const updateReducer: Reducer<BannersState, Update> = (state, action) => {
  return produce(state, draft => {
    draft.byId = action.byId as Map<number, Banner>;
  });
};

export const actions = Object.freeze({
  clear: createCreator<void>(Types.CLEAR),
  update: createCreator<Update>(Types.UPDATE)
});

export const reducer = createReducer(initialState, {
  [Types.CLEAR]: clearReducer,
  [Types.UPDATE]: updateReducer
});
